import { SET_LIFECYCLE_PHASE } from "../actions/types";
import { AppLifecycle, AppLifecyclePhase } from "../models/refsixState";

const initialState: AppLifecycle = {
    phase: AppLifecyclePhase.INITIALIZING,
};

function appLifecycleReducer(
    state: AppLifecycle = initialState,
    action: any
): AppLifecycle {
    switch (action.type) {
        case SET_LIFECYCLE_PHASE:
            return {
                ...state,
                phase: action.phase,
                error: action.error,
            };
        default:
            return state;
    }
}

export default appLifecycleReducer;
